import {
  SupportedTableColumnId,
  WidgetConfig,
  WidgetDataSource,
  WidgetFilters,
  WidgetType,
} from "./WidgetDto";

export const SUPPORTED_CHART_SORTINGS = [
  "x-axis-asc",
  "x-axis-desc",
  "y-axis-asc",
  "y-axis-desc",
] as const;

export type WidgetChartSorting = (typeof SUPPORTED_CHART_SORTINGS)[number];

export const SUPPORTED_CHART_TYPES = [
  "line",
  "area",
  "column",
  "bar",
  "pie",
  "donut",
  "treemap",
  "radar",
  "waterfall",
  "pyramid",
  "funnel",
] as const;

export type WidgetChartType = (typeof SUPPORTED_CHART_TYPES)[number];

export const SUPPORTED_CHART_Y_AXIS_FORMATS = ["value", "percent"] as const;

export type WidgetChartYAxisFormat =
  (typeof SUPPORTED_CHART_Y_AXIS_FORMATS)[number];

export const SUPPORTED_CHART_DATE_TYPES = [
  "inserted_at",
  "due_at",
  "completed_on",
  "updated_at",
] as const;

export type WidgetDataDateType = (typeof SUPPORTED_CHART_DATE_TYPES)[number];

export interface ExpectedWidgetMetadata {
  // Common
  date_type: WidgetDataDateType;
  // Chart specific
  y_axis_format: WidgetChartYAxisFormat;
  sorting: WidgetChartSorting;
  color_palette: string[];
  show_unassigned_categories: boolean;
  // KPI Card specific
  additional_text: string;
  // Table specific
  table_page_size: number;
  table_sort_by: SupportedTableColumnId;
  table_sort_order: "asc" | "desc";
}

export interface WidgetModel {
  id: string;
  title: string;
  type: WidgetType;
  data_src: WidgetDataSource;
  filters: WidgetFilters;
  config: WidgetConfig<WidgetChartType, ExpectedWidgetMetadata>;
  dashboard_id: string;
  updated_at: string;
}
